import { Locale } from "next-intl";

export interface PageParams {
  locale: Locale;
}

export const baseUrl = "https://esimcard.com";
export const apiUrl = process.env.NEXT_PUBLIC_BASE_API;

export const homePath = "/";
export const dataOnlyPath = "/esim/";
export const virtualNumberPath = "/virtual-number/";
export const partnersPath = "/partners/";
export const affiliatePath = "/partners/affiliate/";
export const resellerApiPath = "/partners/reseller-api/";
export const esimCompatiblePath = "/esim-compatible/";
export const internationalCallingPath = "/international-calling/";
export const faqsPath = "/faqs/";
export const helpCenterPath = "/help-center/";
export const aboutUsPath = "/about-us/";
export const blogsPath = "/blog/";
export const contactUsPath = "/contact-us/";
export const careersPath = "/careers/";
export const termsOfServicePath = "/terms/";
export const privacyPolicyPath = "/privacy-policy/";
export const refundPolicyPath = "/refund-policy/";
export const loginPath = "/login/";
export const registerPath = "/register/";
export const passwordResetPath = "/password/reset/";
export const refillPath = "/refill/";
export const mySimsPath = "/client/my-sims/";
export const profilePath = "/client/profile/";
export const dataOnlySimPath = "/client/my-sim/";
export const dataVoiceSimPath = "/client/my-sim/voice/";
export const dataOnlyRegionalPath = "/regional/";
export const dataOnlyEuropePath = "/regional/europe/";
export const dataOnlyGlobalPath = "/global/";
export const dataVoicePath = "/data-voice-sms/";
export const dataVoiceRegionalPath = "/data-voice-sms/regional/";
export const dataVoiceGlobalPath = "/international-calling/";
export const checkoutPath = "/checkout/";
export const redeemPath = "/redeem/";
export const thankYouPath = "/sim-buy-thank-you/";
export const downloadappPath = "/download-app/";
export const orangeEuropeEsim = "/orange-europe-esim/";
export const orangeGlobalEsimDetail = "/orange-global-esim-detail/";
export const renewSimPath = "/renew-sim/";
